import React from 'react'
import { WithCommon, ActionHeader } from '../Common'
import { JIAMENG_GOODS_PATH, CASE_MANAGE_PATH } from '@constant'

export default WithCommon(props => {
  return (
    <ActionHeader
      {...props}
      config={[
        {
          title: '商品管理',
          value: '1',
          route: 'jiaMengGoods',
          link: JIAMENG_GOODS_PATH,
          back: '返回商品管理'
        },
        {
          title: '案例管理',
          value: '2',
          route: 'case',
          link: CASE_MANAGE_PATH,
          back: '返回案例管理'
        }
      ]}
    />
  )
})
